import React from 'react';
import loadable from '@loadable/component';

const TopXIndexContainer = loadable(() => import('./TopXIndexContainer'));
const TopXListContainer = loadable(() => import('./TopXListContainer'));

export const TopXListRoute = () => ({
  path: 'lists',

  indexRoute: require('routes/NotFound').default(),

  childRoutes: [
    {
      path: ':city',
      component: props => <TopXIndexContainer {...props} />,
    },
    {
      path: ':city/*',
      component: props => <TopXListContainer {...props} />,
    },
  ],
});
